import { IUsersService } from './IUsersService';
import { UsersService } from './UsersService';

export const user: IUsersService = new UsersService();
